import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "ProductSKU" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_12 = { for: "VariantValues" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_17 = { for: "Quantity" }
const _hoisted_18 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_19 = { for: "UnitPrice" }
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { for: "SubTotal" }
const _hoisted_22 = { class: "form-control numeric" }
const _hoisted_23 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_24 = { class: "col-md-6 form-group" }
const _hoisted_25 = { for: "DiscountAmount" }
const _hoisted_26 = { class: "form-control numeric" }
const _hoisted_27 = { class: "col-md-6 form-group" }
const _hoisted_28 = { for: "TaxableAmount" }
const _hoisted_29 = { class: "form-control numeric" }
const _hoisted_30 = { class: "col-md-6 form-group" }
const _hoisted_31 = { for: "TaxValue" }
const _hoisted_32 = { class: "form-control numeric" }
const _hoisted_33 = { class: "col-md-6 form-group" }
const _hoisted_34 = { for: "TotalAmt" }
const _hoisted_35 = { class: "form-control numeric" }
const _hoisted_36 = { class: "modal-footer" }
const _hoisted_37 = { class: "d-flex justify-content-end" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ProductSKU.$error}])
            }, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.language.product), 1),
              _withDirectives(_createElementVNode("select", {
                id: "ProductSKU",
                name: "ProductSKU",
                class: "form-control-sel",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.ProductSKU) = $event)),
                disabled: _ctx.isSavingRecord,
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onProductChange && _ctx.onProductChange(...args)))
              }, [
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.language.select_product), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theListProds, (oProd) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: oProd.SKU,
                    value: oProd.SKU
                  }, _toDisplayString(oProd.Name), 9, _hoisted_10))
                }), 128))
              ], 40, _hoisted_8), [
                [_vModelSelect, _ctx.dataRecord.ProductSKU]
              ]),
              (_ctx.v$.dataRecord.ProductSKU.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.dataRecord.ProductSKU.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.dataRecord.ProductOrient == 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': !_ctx.isVariantSet}])
                }, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.variant), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "VariantValues",
                    name: "VariantValues",
                    class: "form-control-sel",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.VariantValues) = $event)),
                    disabled: _ctx.isSavingRecord,
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onVariantChange && _ctx.onVariantChange(...args)))
                  }, [
                    _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.language.select_variant), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specificVariants, (oProd) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: oProd.IdVariantDetail,
                        value: oProd.VariantValues
                      }, _toDisplayString(oProd.VariantValues), 9, _hoisted_15))
                    }), 128))
                  ], 40, _hoisted_13), [
                    [_vModelSelect, _ctx.dataRecord.VariantValues]
                  ]),
                  (!_ctx.isVariantSet)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.language.fldRequired), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Quantity.$error}])
            }, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.language.qty), 1),
              _createVNode(_component_numeric_fld_input, {
                placeholder: '(' + _ctx.language.qty.toLowerCase() + ')',
                id: "Quantity",
                modelValue: _ctx.dataRecord.Quantity,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.Quantity) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdQuoteDet != 0,
                onChange: _ctx.changeSousTotalRecs
              }, null, 8, ["placeholder", "modelValue", "disabled", "onChange"]),
              (_ctx.v$.dataRecord.Quantity.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.v$.dataRecord.Quantity.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.UnitPrice.$error}])
            }, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.language.unit_price), 1),
              _createVNode(_component_numeric_fld_input, {
                id: "UnitPrice",
                placeholder: '(' + _ctx.language.unit_price.toLowerCase() + ')',
                modelValue: _ctx.dataRecord.UnitPrice,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.UnitPrice) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdQuoteDet != 0,
                onChange: _ctx.changeSousTotalRecs
              }, null, 8, ["placeholder", "modelValue", "disabled", "onChange"]),
              (_ctx.v$.dataRecord.UnitPrice.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.dataRecord.UnitPrice.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SubTotal.$error}])
            }, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.sub_total), 1),
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.SubTotal)), 1),
              (_ctx.v$.dataRecord.SubTotal.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.v$.dataRecord.SubTotal.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.language.discount), 1),
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.DiscountAmount)), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.language.taxable_amt), 1),
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.TaxableAmount)), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.language.tax), 1),
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.TaxValue)), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.language.total), 1),
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dataRecord.TotalAmt)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_38),
            (_ctx.dataRecord.IdQuoteDet == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid || _ctx.isSavingRecord
                }, [
                  (_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_39))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}